import parser from "./parser";
import validator from "./validator";

const TemplateBuilder = {
  parser,
  validator,
};

export default TemplateBuilder;
